import { render, staticRenderFns } from "./HelpHeaderButton.vue?vue&type=template&id=432bf058&"
import script from "./HelpHeaderButton.vue?vue&type=script&lang=ts&"
export * from "./HelpHeaderButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports